var _path, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgNoWinner(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.3 6.4H16.2V5.7C16.2 5.51435 16.1263 5.3363 15.995 5.20503C15.8637 5.07375 15.6857 5 15.5 5H8.5C8.31435 5 8.1363 5.07375 8.00503 5.20503C7.87375 5.3363 7.8 5.51435 7.8 5.7V6.4H5.7C5.51435 6.4 5.3363 6.47375 5.20503 6.60503C5.07375 6.7363 5 6.91435 5 7.1V9.2C5 12.217 6.26 14.037 8.374 14.1C8.68245 14.6334 9.10447 15.0923 9.61013 15.4444C10.1158 15.7964 10.6927 16.0329 11.3 16.137V17.6H9.9V19H14.1V17.6H12.7V16.137C13.3073 16.0329 13.8842 15.7964 14.3899 15.4444C14.8955 15.0923 15.3176 14.6334 15.626 14.1C17.726 14.03 19 12.21 19 9.2V7.1C19 6.91435 18.9263 6.7363 18.795 6.60503C18.6637 6.47375 18.4857 6.4 18.3 6.4ZM6.4 9.2V7.8H7.8V12.581C6.554 12.056 6.4 10.11 6.4 9.2ZM16.2 12.581V7.8H17.6V9.2C17.6 10.11 17.446 12.056 16.2 12.581Z",
    fill: "url(#paint0_linear_186_10963)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_186_10963",
    x1: 3.97181,
    y1: 5,
    x2: 19,
    y2: 19,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFD648"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#AA5E1B"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoWinner);
export default __webpack_public_path__ + "static/media/no-winner.03ed8ba5428f234fe4d952f4b68d8344.svg";
export { ForwardRef as ReactComponent };